import {
    min as _min,
    keyBy as _keyBy,
    mapValues as _mapValues,
    } from '@lodash';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import { ILottoTicketItemDto } from '@core/mappers/tickets/dtos/ISubmittingTicketDto';
import DateUtils from '@utils/date/DateUtils';
import ILottoBetSlipDTO from '@core/models/lottoBetSlip/ILottoBetSlipDto';
interface PropagatedAttributes {
    isSystem: boolean;
}
export default class LottoBetSlipItemMapper extends AbstractMapper<ILottoBetSlipDTO, ILottoTicketItemDto> {

    createTargetObject(data: ILottoBetSlipDTO, propagatedAttributes: PropagatedAttributes) {
        const odds = _mapValues(_keyBy(data.odds, 'order'), 'value');

        return {
            odds,
            // OBA fields start
            // event and its code missing for lotto mapper ???
            eventCode: data.code,
            eventId: data.eventId,
            eventName: data.name,
            // OBA fields end
            betEnd: DateUtils.toString(DateUtils.inUtcTime(data.endBet)),
            lotoOfferId: data.eventId,
            lotoId: data.lottoId,
            lottoName: data.name,
            maxNums: data.numbersDrawn.toString(),
            num: _min(data.selections),
            nums: data.selections,
            rules: data.rules,
            selected: true,
            type: 'lotto',
            // okay if undefined
            value: odds[data.selections.length]
        } as unknown as ILottoTicketItemDto;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/tickets/LottoBetSlipItemMapper.ts